import { uniqBy } from 'lodash/fp';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import FilterGroup from '../../../StandardApplicationEntrypoint/CarListingPage/CarFilter/FilterGroup';
import { useCarListingState } from '../CarListingStateProvider';

const CarModelFilter = () => {
    const { t } = useTranslation(['carList']);
    const translateString = useTranslatedString();
    const {
        state: { filters, modelFilter },
        actions,
    } = useCarListingState();

    const onChange = useCallback(
        (value: string[]) => {
            actions.setModelFilter(value.length > 0 ? value : null);
            actions.setScroll(false);
            actions.setPage(1);
        },
        [actions]
    );

    const options = useMemo(
        () =>
            uniqBy(
                'value',
                filters.models.map(model => ({
                    label: translateString(model),
                    value: translateString(model),
                }))
            ),
        [filters.models, translateString]
    );

    if (!options?.length || options.length === 1) {
        return null;
    }

    return (
        <FilterGroup
            onChange={onChange}
            options={options}
            title={t('carList:filter.carModelTitle')}
            value={modelFilter || []}
        />
    );
};

export default CarModelFilter;
